import { useParams } from 'react-router-dom';
import { Button, Container } from 'reactstrap';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import FilterDataTableObjectDocs from './DataTableComponents/FilterObjectDocsTable';
import AddObjectDocModal from './Modals/AddObjectDocModal';
import ObjectDocDeleteModal from './Modals/DeleteObjectDocModal';
import ExpandableObjectDocs from './DataTableComponents/ExpandableObjectDocs';

import useGetObjectDocs from 'hooks/ObjectDocs/useGetObjectDocs';
import { useGetDocumentListTableColumns } from 'components/ObjectDocs/useGetObjectDocsTableColumns';
import useScreenSize from 'hooks/Screen/useScreenSize';
import { Document } from 'api/objectDocs/type';
import Icon from 'assets/images/documents-icon.svg';

const ObjectDocsDetailPage = () => {
  const { t } = useTranslation();
  let { slug } = useParams();
  const { data, isLoading, refetch } = useGetObjectDocs(slug || '');
  const { isNotDesktop } = useScreenSize();
  const [isMangeModalOpen, setIsManageModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedDocID, setSelectedDocID] = useState<number | null>(null);
  const [selectedDocName, setSelectedDocName] = useState<string>('');

  const handleDeleteClick = (docID: number, docName: string) => {
    setSelectedDocID(docID);
    setSelectedDocName(docName);
    setIsDeleteModalOpen(true);
  };

  const handleCloseDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedDocID(null);
    setSelectedDocName('');
  };

  const columns = useGetDocumentListTableColumns({
    onDeleteClick: handleDeleteClick,
  });

  useEffect(() => {
    refetch();
  }, [data, refetch]);

  return (
    <Container fluid>
      <div className="row">
        <div className="col-12">
          <div className="card rounded-4 border-2">
            <div className="card-header rounded-4">
              <div className="row d-flex align-items-center">
                <div className="col-xl-6">
                  <div className="title d-flex align-items-center gap-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                    <div className="mx-2">
                      <img src={Icon} width="40" height="40" alt="Documents Icon" />
                    </div>

                    <div className="d-flex align-items-center h4 mb-0 fw-bold gap-2">
                      {t('ObjectDocs.detail-page.title')}
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 text-end">
                  <AddObjectDocModal
                    slug={slug}
                    isOpen={isMangeModalOpen}
                    onClose={() => {
                      setIsManageModalOpen(false);
                    }}
                  />
                  <Button onClick={() => setIsManageModalOpen(true)} className="btn btn-ghost-success">
                    + {t('ObjectDocs.detail-page.add-btn')}
                  </Button>
                </div>
              </div>
            </div>
            <div className="card-body">
              <FilterDataTableObjectDocs<Document>
                columns={columns}
                data={(data || []) as Document[]}
                isLoading={isLoading}
                expandableRows={isNotDesktop}
                expandableRowsComponent={row => (
                  <ExpandableObjectDocs data={row.data} slug={slug || ''} onDeleteClick={handleDeleteClick} />
                )}
              />
            </div>
          </div>
        </div>
      </div>

      {isDeleteModalOpen && selectedDocID !== null && (
        <ObjectDocDeleteModal
          slug={slug || ''}
          docID={selectedDocID}
          docName={selectedDocName}
          isOpen={isDeleteModalOpen}
          onClose={handleCloseDeleteModal}
        />
      )}
    </Container>
  );
};

export default ObjectDocsDetailPage;
